<template>
  <div
    id="vendor-assess-external-input-questions"
    class="tw-py-5 tw-px-5 md:tw-py-[55px] md:tw-px-[60px] tw-flex tw-flex-col tw-gap-5 tw-rounded-b-[6px]"
    style="background: var(--UI-rule-50, rgba(239, 240, 241, 0.5))"
  >
    <RightSlideModal
      :is-show="isOverlayVisible"
      @show="isOverlayVisible = true"
      @close="isOverlayVisible = false"
    />
    <div
      v-show="isOverlayVisible"
      class="overlay color"
      @click="closeRightSliderMenu"
    />

    <div
      id="vendor-assess-external-input-questions"
      class="tw-flex tw-flex-col tw-justify-between tw-w-full tw-gap-5"
    >
      <AssessmentCategoryHeader
        :title="
          getComponentUiText(
            'app-assess-recommendations-section-assessment-questions-1',
          )
        "
        :class-name="'tw-text-[20px]'"
      />

      <div
        class="tw-flex tw-justify-between tw-items-center tw-flex-wrap tw-gap-5"
      >
        <div id="vendor-assess-external-input-questions-search-box">
          <BaseSearchbox
            :class="[
              'tw-relative tw-h-[44px] tw-rounded-[6px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#ffffff] tw-pt-[10px] tw-pb-[8px] tw-px-[15px] tw-w-[450px]',
            ]"
            :model-value="search"
            :placeholder="getComponentUiText('app-table-search-prompt-text-1')"
            @update:model-value="($event) => (search = $event)"
          />
        </div>
        <div
          id="vendor-assess-external-input-notes"
          class="tw-flex tw-items-center tw-flex-wrap xl:tw-gap-[20px] tw-gap-2"
        >
          <div @click="handleShowBulkAction">
            <ButtonBulkActions
              :id-popover="'popover-btn-bulk-action-assessment'"
              :active="selectedQuestionsChild.length >= 1"
              :is-margin-right="false"
              :show-more-actions="isShowMoreActions"
              :selected-number="
                selectedQuestionsChild.length > 0
                  ? selectedQuestionsChild.length
                  : ''
              "
              :show-acction-click="true"
            >
              <CustomDropDownItem
                :style="'normal'"
                :id-text="'app-component-assessments-question-bulk-action-item-reset-answers-1'"
                :id-item="`vendor-assess-external-input-reset-answers`"
                @click="showModalResetAnswers"
              />
            </ButtonBulkActions>
          </div>

          <div>
            <ButtonFilter
              :active="false"
              :id-popover="'popover-btn-filter-assessment'"
              :is-margin-right="false"
            />
          </div>
          <div
            id="chr-vendor-display-settings popover-target-1"
            data-cy="vendor-display-settings"
            class="toggle-switch-view tw-relative tw-px-[14px] tw-py-[10px]"
            :class="isCheckToggleOptionSetting ? 'setting-option-selected' : ''"
            @click="openDisplayOption"
            @mouseover="isCogHover = true"
            @mouseout="isCogHover = false"
          >
            <label class="tw-cursor-pointer">
              <span class="">
                <img
                  v-if="isCheckToggleOptionSetting"
                  src="@/assets/img/setting_option_selected.svg"
                  alt=""
                />
                <img
                  v-else-if="!isShowToolTip && !isCogHover"
                  src="@/assets/img/setting_option.svg"
                  alt=""
                />
                <img
                  v-else
                  src="@/assets/img/setting_option_active.svg"
                  alt=""
                />
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!isLoadingRequestedInput"
      id="vendor-assessment-question-detail"
      class="tw-flex tw-flex-col tw-gap-[20px] tw-w-full tw-rounded-[6px]"
    >
      <VendorAssessmentQuestionsDetail
        v-for="(item, idxHeading) in listQuestion"
        :key="item?.itemMasterId"
        :idx-heading="idxHeading + 1"
        :assessment-question="item"
        :selected-questions="selectedQuestions"
        :compliance-type-values="complianceTypeValues"
        :data-vendor="dataVendor"
        @update:selected-questions="handleSelectedQuestions"
      />
    </div>
    <AssessmentQuestionSubCategorySkeleton
      v-else
      custom-class="!tw-max-w-[100%]"
    >
    </AssessmentQuestionSubCategorySkeleton>

    <div class="tw-mt-[10px]">
      <VendorAssessmentNote
        id="vendor-assess-external-input-questions-notes"
        :note="dataVendor?.notesResponse ?? ''"
        :is-loading="isLoadingRequestedInput"
        :disable="!isCheckStatusInprogAndWait"
        @update:blur="($event) => handlePutNoteResponse($event)"
      />
    </div>

    <!-- Actions  -->
    <div class="tw-flex tw-mt-[10px] tw-justify-between tw-items-center">
      <div>
        <span
          class="tw-font-Poppins tw-text-[13px] tw-font-[500] tw-text-[#231F20]"
        >
          {{ currentPage }}/{{ totalPages }}
          {{
            getComponentUiText("app-component-assessments-questions-answered-1")
          }}</span
        >
      </div>
      <button
        id="vender-view-assessment-btn"
        data-cy="vender-submit-assessment-btn"
        :class="`tw-flex tw-items-center tw-bg-[#387DFF] tw-rounded-[100px] tw-px-[20px] tw-py-[8px] !tw-h-[39px] submit-button ${
          !isCheckStatusInprogAndWait ? 'disabled' : ''
        }`"
        :disabled="!isCheckStatusInprogAndWait"
        @click="() => handleSubmit()"
      >
        <span
          v-if="!isLoadingAPI"
          ref="innerTextSubmitBtnRef"
          class="tw-text-[15px] tw-font-[500] tw-font-[Poppins] tw-leading-[100%] tw-text-white"
        >
          {{
            getComponentUiText("app-assessments-vendor-questions-btn-submit-1")
          }}
        </span>
        <div
          v-else
          :style="{ width: animationWidth + 'px' }"
          class="tw-flex tw-justify-center tw-h-[39px] tw-w-[39px] tw-text-[#FFF]"
        >
          <!-- eslint-disable vue/no-unused-refs -->
          <LottieAnimation
            ref="anim"
            :animation-data="ProgressAnimation"
            :auto-play="true"
            :loop="true"
          />
        </div>
      </button>
    </div>
  </div>
  <b-popover
    ref="popover_option"
    target="chr-vendor-display-settings popover-target-1"
    placement="bottom-end"
    click="true"
    :offset="20"
    :custom-class="`custom-actions-popover assessment-display-options`"
    class="tw-absolute"
    @show="isShowToolTip = true"
    @hidden="isShowToolTip = false"
  >
    <AssessmentDisplayOptions
      :list-option="listOption"
      :class="'!tw-w-[240px]'"
    />
  </b-popover>
</template>

<script lang="ts" setup>
import { Ref, ref, computed, onMounted, watch } from "vue";
import {
  formatVendorData,
  getComponentUiText,
  searchQuestion,
} from "@/utils/utilities";
import AssessmentCategoryHeader from "@/components/assessment/assessmentCategoryHeader.vue";
import ButtonBulkActions from "@/components/common/setting/buttonBulkActions.vue";
import ButtonFilter from "@/components/common/setting/buttonFilter.vue";
import VendorAssessmentQuestionsDetail from "./vendorAssessmentQuestionsDetail.vue";
import VendorAssessmentNote from "./vendorAssessmentNote.vue";
import Button1 from "../common/button1.vue";
import store from "@/store";
import AssessmentDisplayOptions from "../assessment/assessmentDisplayOptions.vue";
import BaseSearchbox from "../common/form/baseSearchbox.vue";
import RightSlideModal from "@/components/common/rightSlideModal.vue";
import {
  COMPLIANCE_TYPE,
  infomationRequiredId,
  localStorageKey,
  MODAL_NAME,
  successStatusCodes,
} from "@/utils/constants";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import {
  deleteChecklistRequestedAttachment,
  IParamsUpdateChecklistRequestedItems,
  putRequestAssessmentEmail,
  updateChecklistRequestedExternalItem,
} from "@/services/vendor";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Vendor } from "@/services/apiRoutes/routes";
import { postRequestAssessmentEmailSubmit } from "@/services/vendor";
import router from "@/router";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IModalMessage } from "@/interfaces/common/common";
import AssessmentQuestionSubCategorySkeleton from "../skeleton/assessmentQuestionSubCategorySkeleton.vue";
import ProgressAnimation from "../../assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";

const selectedQuestions: Ref<any> = ref([]);
const selectedQuestionsChild: Ref<any> = ref([]);
const search = ref("");
const isCogHover: Ref<boolean> = ref(false);
const isShowToolTip: Ref<boolean> = ref(false);
const isCheckToggleOptionSetting: Ref<boolean> = computed(
  () => hideComplete.value || hideReviewed.value || infomationRequired.value,
);
const currentPage = ref(1);
const totalPages = ref(25);
const popover_option: any = ref(null);
const isShowMoreActions = ref(false);
let checklistRequestedNotes = undefined;

const hideComplete: any = ref(
  localStorage.getItem(localStorageKey.isHideCompleteVendorInput) === "true",
);
const hideReviewed: any = ref(
  localStorage.getItem(localStorageKey.isHideCompleteVendorReview) === "true",
);
const isLoadingAPI = ref(false);
const innerTextSubmitBtnRef: Ref = ref(null);
const animationWidth = ref(0);

const isLoadingRequestedInput = computed(
  () => store.state.Vendor.isLoadingRequestedInput,
);

const infomationRequired: any = ref(null);
const listOption = computed(() => [
  {
    title: getComponentUiText(
      "app-component-assessment-vendor-display-options-filter-hide-complete-1",
    ),
    value: hideComplete.value,
    action: hideCompleteAction,
    dataCy: "assessment-display-options-hide-complete",
  },
  {
    title: getComponentUiText(
      "app-component-vendor-assessment-display-options-hide-reviewed-1",
    ),
    value: hideReviewed.value,
    action: hideReviewedAction,
    dataCy: "assessment-display-options-hide-reviewed",
  },
  {
    title: getComponentUiText(
      "app-component-vendor-question-information-required-1",
    ),
    value: infomationRequired.value,
    action: infomationRequiredAction,
    dataCy: "assessment-display-options-information-required",
  },
]);
const isOverlayVisible = ref(false);
const closeRightSliderMenu = () => {
  isOverlayVisible.value = false;
};

const listQuestion: any = computed(() => {
  let dataFilter = dataVendor.value?.checklistRequestedItems ?? [];

  if (hideReviewed.value) {
    dataFilter = dataFilter.filter(
      (item: any) => !checkQuestionIsReviewed(item),
    );
  }

  if (hideComplete.value) {
    dataFilter = dataFilter.filter(
      (item: any) => !checkQuestionIsComplete(item),
    );
  }

  if (infomationRequired.value) {
    dataFilter = dataFilter?.filter(
      (item: any) =>
        (item?.checklistItemNotesOrgExternal &&
          item?.checklistItemComplianceTypeValueOrgId ===
            infomationRequiredId) ||
        item?.checklistItemIsHeading,
    );
  }

  dataFilter = searchQuestion(dataFilter ?? [], search.value) ?? [];

  let dataFormat = formatVendorData(dataFilter);

  if (isCheckToggleOptionSetting.value) {
    dataFormat = dataFormat.filter(
      (item) => item.checklistItemChildren?.length,
    );
  }

  return dataFormat;
});

const dataVendor = computed(
  () => store.state.Vendor?.checklistVendorRequestedExternalInput,
);
const complianceTypeValues = computed(
  () => store.state.Vendor.checklistComplianceTypeValues,
);

const isCheckStatusInprogAndWait = computed(
  () => store.getters["Vendor/isCheckStatusInprogAndWait"],
);

onMounted(() => {
  listenOpenImageModal();
});

watch(
  () => dataVendor.value,
  (newVal) => {
    if (newVal?.checklistRequestedItems && infomationRequired.value === null) {
      infomationRequired.value = newVal?.checklistRequestedItems.some(
        (item: any) => item.checklistItemNotesOrgExternal,
      );
    }
  },
);

const listenOpenImageModal = () => {
  EventEmitter.on(EmitterEvents.OPEN_IMAGE_MODAL, (item: any) => {
    const emitData: IModalMessage = {
      component: MODAL_NAME.MODAL_VENDOR_ASSESSMENT_ATTACHMENT,
      properties: {
        urlAttachment: item.urlAttachment,
      },
    };

    EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  });
};

const childQuestionId = computed(() => {
  const childData = dataVendor.value?.checklistRequestedItems.filter(
    (item: any) =>
      item.checklistItemComplianceTypeId !== "na" &&
      item.checklistItemComplianceTypeId !== null,
  );
  return childData.map((item: any) => item.itemMasterId);
});
const checkQuestionIsComplete = (item: any) => {
  switch (item?.checklistItemComplianceTypeId) {
    case COMPLIANCE_TYPE.ATTACH:
      return item?.checklistItemAttachments?.length;
    case COMPLIANCE_TYPE.YES_NO:
      return item?.checklistItemComplianceTypeValueId !== null;
    case COMPLIANCE_TYPE.TEXT:
      return item?.checklistItemCompensatingControlDescription;
    default:
      return false;
  }
};

const checkQuestionIsReviewed = (item: any) => {
  return (
    item.checklistItemComplianceTypeValueOrgId ||
    item.checklistItemComplianceOverride
  );
};
const openDisplayOption = () => {
  setTimeout(() => {
    popover_option?.value?.$emit("show");
  }, 500);
};

const hideCompleteAction = () => {
  hideComplete.value = !hideComplete.value;
  localStorage.setItem(
    localStorageKey.isHideCompleteVendorInput,
    JSON.stringify(hideComplete.value),
  );
};

const hideReviewedAction = () => {
  hideReviewed.value = !hideReviewed.value;
  localStorage.setItem(
    localStorageKey.isHideReviewedVendorInput,
    JSON.stringify(hideReviewed.value),
  );
};

const infomationRequiredAction = () => {
  infomationRequired.value = !infomationRequired.value;
};

const handleSelectedQuestions = (value: any) => {
  const id = value.item?.itemMasterId;
  const idChildrent =
    value.item?.checklistItemChildren?.map((item: any) => item.itemMasterId) ??
    [];
  if (selectedQuestions.value.includes(id)) {
    selectedQuestions.value = selectedQuestions.value.filter(
      (item: any) => item !== id,
    );
    idChildrent.forEach((item: any) => {
      selectedQuestions.value = selectedQuestions.value.filter(
        (child: any) => child !== item,
      );
    });
  } else {
    selectedQuestions.value = [...selectedQuestions.value, id];
    idChildrent.forEach((item: any) => {
      if (!selectedQuestions.value.includes(item)) {
        selectedQuestions.value = [...selectedQuestions.value, item];
      }
    });
  }
  selectedQuestionsChild.value = selectedQuestions.value.filter((id: number) =>
    childQuestionId.value.includes(id),
  );
};

const handleShowBulkAction = () => {
  isShowMoreActions.value = !isShowMoreActions.value;
};

const handleUpdateItems = async () => {
  const checklistRequestedId: number = dataVendor.value?.checklistRequestedId;
  const selectedQuestionsData =
    dataVendor.value?.checklistRequestedItems.filter((item: any) => {
      return (
        selectedQuestions.value.includes(item.itemMasterId) &&
        item.checklistItemComplianceTypeId !== null &&
        item.checklistItemComplianceTypeId !== "na"
      );
    });
  const checklistItemAttachments: [] = selectedQuestionsData.filter(
    (item: any) =>
      item.checklistItemComplianceTypeId === COMPLIANCE_TYPE.ATTACH &&
      item.checklistItemAttachments.length > 0,
  );
  const updatCheckListParams: IParamsUpdateChecklistRequestedItems = {
    checklistRequestedItems: selectedQuestionsData.map((item: any) => {
      if (
        item.checklistItemComplianceTypeId === COMPLIANCE_TYPE.YES_NO ||
        item.checklistItemComplianceTypeId === COMPLIANCE_TYPE.ATTACH
      ) {
        return {
          checklistRequestedItemId: item.checklistItemId,
          complianceTypeValueId: null,
        };
      }
      if (item.checklistItemComplianceTypeId === COMPLIANCE_TYPE.TEXT) {
        return {
          checklistRequestedItemId: item.checklistItemId,
          compensatingControlDescription: "",
        };
      }
    }),
  };
  try {
    const deleteAttachmentPromises = checklistItemAttachments.map(
      (item: any) => {
        const attachmentIds = item.checklistItemAttachments.map(
          (attachment: any) => attachment.attachmentId,
        );
        if (attachmentIds.length) {
          return deleteChecklistRequestedAttachment({
            checklistItemId: item.checklistItemId,
            checklistRequestedId,
            checklistItemAttachmentIds: attachmentIds,
          });
        }
        return Promise.resolve();
      },
    );
    const [updateRes, ...deleteAttachmentResRaw] = await Promise.all([
      updateChecklistRequestedExternalItem(
        checklistRequestedId,
        updatCheckListParams,
      ),
      ...deleteAttachmentPromises,
    ]);
    const deleteAttachmentRes = deleteAttachmentResRaw.filter(
      (res) => res !== undefined,
    );
    if (
      updateRes.status === successStatusCodes.OK ||
      deleteAttachmentRes.some((res) => res.status === successStatusCodes.OK)
    ) {
      await store.dispatch("Vendor/fetchVendorRequestedExternalInput");
      EventEmitter.emit(EmitterEvents.CLOSE_MODAL);
      selectedQuestions.value = [];
      selectedQuestionsChild.value = [];
    }
  } catch (error) {
    showErrorAPI(error, Vendor.putChecklistRequestedExternalItem);
  }
};

const showModalResetAnswers = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-assessment-modal-bulk-reset-answers-header-1",
      ),
      class: "tw-top-[0px]",
      description: getComponentUiText(
        "app-assessment-modal-bulk-reset-answers-description-1",
        false,
        { numberQuestions: selectedQuestionsChild.value.length.toString() },
      ),
      hiddenHelp: false,
      buttonText: getComponentUiText(
        "app-assessment-modal-reset-answers-button-text-1",
      ),
      buttonRed: true,
    },
    events: {
      "update:data": () => {
        handleUpdateItems();
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const handleSubmit = async () => {
  if (isLoadingAPI.value) return;
  isLoadingAPI.value = true;
  if (innerTextSubmitBtnRef.value) {
    animationWidth.value = innerTextSubmitBtnRef.value.getBoundingClientRect()[
      "width"
    ] as number;
  }
  try {
    const checklistRequestedId = dataVendor.value.checklistRequestedId;
    const res = await postRequestAssessmentEmailSubmit(checklistRequestedId);
    if (res.status === successStatusCodes.OK) {
      router.push({
        name: "AssessmentVendorSubmit",
        query: { orgName: dataVendor.value.orgName },
      });
    }
  } catch (error: any) {
    isLoadingAPI.value = false;
    showErrorAPI(error, Vendor.getRequestedAssessment);
  }
};

const handlePutNoteResponse = async (val) => {
  try {
    if (checklistRequestedNotes === undefined) {
      checklistRequestedNotes = dataVendor.value.notesResponse || "";
    }
    if (val === checklistRequestedNotes) return;
    checklistRequestedNotes = val;
    const checklistRequestedId = dataVendor.value.checklistRequestedId;
    const res = await putRequestAssessmentEmail(checklistRequestedId, val);
    if (res.status === successStatusCodes.OK) {
      showSuccessToast(
        getComponentUiText("app-assessments-vendor-questions-note-success-1"),
      );
    }
  } catch (error: any) {
    showErrorAPI(error, Vendor.getRequestedAssessment);
  }
};
</script>

<style lang="scss" scoped>
.box-shadow-contain {
  box-shadow: 2px 0px 20px 0px rgba(33, 31, 88, 0.1);
}

.search-box {
  border-radius: 6px;
  border: 1px solid var(--ui-rule, #eff0f1);
  padding: 11px 15px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  max-width: 450px;
  width: 100%;
  outline: none;
  background: white;
  margin-right: 15px;
}

.search-box input {
  border: none;
  outline: none;
  width: 100%;
  margin-left: 10px;
}
.toggle-switch-view {
  border-radius: 6px;
  background: var(--ui-white, #fff);
  backdrop-filter: blur(6px);
  // padding: 4px;
  align-items: center;
  display: inline-flex;

  label {
    margin-bottom: 0;
  }
  .label {
    display: flex;
    cursor: pointer;
    padding: 10px 18px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 0;
    color: var(--ui-light-grey, #b7b7b7);
    letter-spacing: 1px;
    border-radius: 6px;
    min-width: 16px;
    // Keep this coded out for now

    // min-width: 111px;
    // background: var(--brand-navy, #211F58);
  }

  input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;

    &:checked + .label {
      background: var(--brand-navy, #211f58);
      color: #fff;
    }
  }
  &.setting-option-selected {
    background: var(--brand-navy, #211f58);
  }
}

.disabled {
  pointer-events: none;
  background-color: #62a2f5;
}

.submit-button {
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
}
</style>
